"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "forli": {
    "c408d2af": [{
      "hkey": "6df885d4",
      "slug": "cava-villanova",
      "name": "Cava-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "cava": [{
      "hkey": "6df885d4",
      "slug": "cava-villanova",
      "name": "Cava-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fe7cbeb8": [{
      "hkey": "1cf87089",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "1cf87089",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d046a5eb": [{
      "hkey": "9738e3a9",
      "slug": "foro-boario-ospedaletto-pianta-san-benedetto",
      "name": "Foro Boario-Ospedaletto-Pianta-San Benedetto",
      "primary": true,
      "skipSearch": false
    }],
    "prima-periferia": [{
      "hkey": "9738e3a9",
      "slug": "foro-boario-ospedaletto-pianta-san-benedetto",
      "name": "Foro Boario-Ospedaletto-Pianta-San Benedetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "07cfc6b7": [{
      "hkey": "5ad8f149",
      "slug": "resistenza",
      "name": "Resistenza",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "5ad8f149",
      "slug": "resistenza",
      "name": "Resistenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;